import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box, Typography, CardContent } from "@mui/material";
import Card from "@mui/material/Card";
import Arrow from "../../../Assets/Svg/offersarrow.svg";
import { Styles } from "./styles";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";

const PanelGroupCard = ({ data }) => {
  const navigate = useNavigate();
    const [logoError, setLogoError] = useState(false);
    const handleNavigation = (uuid) => {
        window.open(`${window.location.origin}/PanelsDetails/${uuid}`, '_blank', 'noopener,noreferrer');
        // navigate(`/AdsPanelsDetails/${uuid}`);
    };
  return (
      <Styles>
          <Box
              className="item-carosel"
              style={{padding : '0',width:'100%'}}
              key={data.id}
              onClick={() => handleNavigation(data.uuid)}
          >

              <div className="final-logo-container" style={{alignContent:'center',minHeight:'100px',margin:'0 20px'}}>
                  <Typography
                      sx={{
                          fontSize: `17px`,
                          color: '#ffffff',
                      }}
                      className="final-logo"
                  >
                      {data.smmpanel_url}
                  </Typography>
                  <Typography
                      sx={{
                          fontSize: `14px`,
                          color: '#ffffff',
                      }}
                      className="final-logo"
                  >
                      {data.smmpanel_name}
                  </Typography>
              </div>

          </Box>
      </Styles>
  );
};

export default PanelGroupCard;
